<template>
  <div class="pw-footer-background">
    <div class="pw-footer-parent">
      <div class="pw-footer-share-icon">
        <div class="pw-footer-share-icon-img">
          <a href="https://www.facebook.com/pawaiipet/">
            <img
              src="../../assets/img/footer/pw-footer-facebook.png"
              alt="facebook"
            />
          </a>
        </div>
        <div class="pw-footer-share-icon-img">
          <a href="https://twitter.com/Pawaiipet">
            <img
              src="../../assets/img/footer/pw-footer-twitter.png"
              alt="twitter"
            />
          </a>
        </div>
        <div class="pw-footer-share-icon-img">
          <a href="https://www.instagram.com/pawaiihub/">
            <img
              src="../../assets/img/footer/pw-footer-instagram.png"
              alt="instagram"
            />
          </a>
        </div>
      </div>
      <div class="pw-footer-copyright">
        <span>© 2023 PAWAii.com. All Rights Reserved.</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "VueFooter",
};
</script>

<style scoped>
.pw-footer-background {
  background-color: #1a1a1a;
  border-top: 4px solid #ff5349;
}
.pw-footer-parent {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 25px 30px;
  max-width: 1110px;
  margin: auto;
}
.pw-footer-share-icon {
  display: flex;
}
.pw-footer-share-icon-img {
  margin-right: 30px;
}
.pw-footer-share-icon .pw-footer-share-icon-img:last-child {
  margin-right: 0;
}
.pw-footer-share-icon-img img {
  width: 30px;
  height: 30px;
  display: block;
}
.pw-footer-copyright span {
  display: block;
  color: #ffffff;
  font-weight: 300;
  font-size: 14px;
  line-height: 21px;
  font-family: "Poppins-Light";
}
@media (max-width: 767px) {
  .pw-footer-parent {
    flex-direction: column;
    padding: 10px 20px;
  }
  .pw-footer-share-icon {
    margin-bottom: 10px;
  }
}
</style>
